module.exports = __webpack_public_path__ + "img/group-2.529d437b.png";